(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    if (!window.__jesoliEmailSignupEnhanced) {
    window.__jesoliEmailSignupEnhanced = true;
    const emailSignupScrollKey = 'jesoli-email-signup-scroll';

    const getPageScrollTop = () => {
      const pageWrapper = document.querySelector('.page-wrapper');
      if (window.matchMedia('(min-width: 990px)').matches && pageWrapper instanceof HTMLElement) {
        return pageWrapper.scrollTop;
      }

      return document.scrollingElement?.scrollTop || window.scrollY || 0;
    };

    const restorePageScrollTop = (scrollTop) => {
      const pageWrapper = document.querySelector('.page-wrapper');
      if (window.matchMedia('(min-width: 990px)').matches && pageWrapper instanceof HTMLElement) {
        pageWrapper.scrollTo({ top: scrollTop, behavior: 'instant' });
        return;
      }

      window.scrollTo({ top: scrollTop, behavior: 'instant' });
    };

    const openSuccessDialog = (wrapper) => {
      if (!(wrapper instanceof HTMLElement)) return;

      const successResult = wrapper.querySelector('[data-email-signup-result][data-state="success"]');
      if (!(successResult instanceof HTMLElement)) return;

      wrapper.classList.add('email-signup--dialog-enhanced');
      const dialog = wrapper.querySelector('[data-email-signup-success-dialog]');
      if (!(dialog instanceof HTMLDialogElement) || dialog.open) return;

      dialog.showModal();
      const closeButton = dialog.querySelector('[data-email-signup-dialog-close]');
      if (closeButton instanceof HTMLButtonElement) closeButton.focus({ preventScroll: true });
    };

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const wrapper = form.closest('[data-email-signup]');
      if (!(wrapper instanceof HTMLElement)) return;

      try {
        sessionStorage.setItem(
          emailSignupScrollKey,
          JSON.stringify({ path: window.location.pathname, scrollTop: getPageScrollTop() })
        );
      } catch (_) {
        // Newsletter submission must still proceed if storage is unavailable.
      }
    });

    const initialiseEmailSignupResult = () => {
      const successfulWrapper = document.querySelector(
        '[data-email-signup]:has([data-email-signup-result][data-state="success"])'
      );
      if (!(successfulWrapper instanceof HTMLElement)) return;

      let savedScroll = null;
      try {
        savedScroll = JSON.parse(sessionStorage.getItem(emailSignupScrollKey) || 'null');
        sessionStorage.removeItem(emailSignupScrollKey);
      } catch (_) {
        savedScroll = null;
      }

      if (savedScroll?.path === window.location.pathname && Number.isFinite(savedScroll.scrollTop)) {
        requestAnimationFrame(() => restorePageScrollTop(savedScroll.scrollTop));
      }

      const url = new URL(window.location.href);
      if (url.searchParams.has('customer_posted') || url.hash === '#contact_form') {
        url.searchParams.delete('customer_posted');
        url.hash = '';
        history.replaceState(history.state, '', `${url.pathname}${url.search}`);
      }

      openSuccessDialog(successfulWrapper);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initialiseEmailSignupResult, { once: true });
    } else {
      initialiseEmailSignupResult();
    }

    document.addEventListener('click', (event) => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      const closeButton = target.closest('[data-email-signup-dialog-close]');
      if (closeButton) {
        const dialog = closeButton.closest('[data-email-signup-success-dialog]');
        if (dialog instanceof HTMLDialogElement) dialog.close();
        return;
      }

      if (target instanceof HTMLDialogElement && target.matches('[data-email-signup-success-dialog]')) {
        target.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
